import { snakeCase, text, varchar, integer } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'

export const approvalStatusTable = snakeCase.table('application_statuses', {
    id: id('aps'),
    name: varchar({ length: 50 }).notNull().unique(), // requested/approved/rejected/allocated/redeemed/expired/cancelled
    description: text(),
    order: integer().notNull().unique(),
    isActive: varchar({ length: 10 }).notNull().default('true'),
    ...timestamps,
})
